module.exports = __webpack_public_path__ + "static/ml-product-hero-background_mobile-faaec92a0cf029885bce783e886702aa.jpg";